import { call, put, takeEvery, fork } from "redux-saga/effects";
import * as actions from "../actions/importadorProductos";
import * as presupuestoActions from "../actions/presupuesto";
import ImportadorProductosService from "../services/importadorProductos";
import MyUserService from "../services/myUser";
import { requestPresupuestoAdd } from "../actions/presupuesto";

function* descargarTemplate() {
  yield put(actions.startLoadingDownload());
  try {
    const success = yield call(ImportadorProductosService.descargarTemplate);
    if (success) {
      yield put(actions.descargarTemplateSuccess());
    } else {
      yield put(
        actions.descargarTemplateError("No se pudo descargar el template"),
      );
    }
  } catch (err) {
    yield put(actions.descargarTemplateError(err));
    console.log(err);
  }
}

function* importarProductos({ formData }: any) {
  yield put(actions.startLoading());
  try {
    const response = yield call(
      ImportadorProductosService.importarProductos,
      formData,
    );
    if (response && response.data.productosEncontrados) {
      yield put(
        actions.importarProductosSuccess(
          response.data.productosEncontrados || [],
          response.data.productosNoEncontrados || [],
        ),
      );
    } else {
      yield put(
        actions.importarProductosError(
          response?.message || "Error al importar productos",
        ),
      );
    }
  } catch (err) {
    yield put(actions.importarProductosError(err));
    console.log(err);
  }
}

function* confirmarImportacion() {
  yield put(actions.limpiarEstado());
  yield put(actions.startLoading());
  try {
    const response = yield call(
      ImportadorProductosService.confirmarImportacion,
    );
    if (response) {
      yield put(
        actions.confirmarImportacionSuccess(
          "Productos agregados al carrito exitosamente",
        ),
      );
      // Actualizar cantidad de items en el carrito
      const myUser = MyUserService.getMyUser();
      if (myUser?.contactoId && myUser?.clienteId) {
        yield put(
          presupuestoActions.requestCantInCarrito(
            myUser.contactoId,
            myUser.clienteId,
          ),
        );
      }
    } else {
      yield put(
        actions.confirmarImportacionError("Error al confirmar importación"),
      );
    }
  } catch (err) {
    yield put(actions.confirmarImportacionError(err));
    console.log(err);
  }
}

function* watchDescargarTemplate() {
  yield takeEvery(actions.Types.DESCARGAR_TEMPLATE_REQUEST, descargarTemplate);
}

function* watchImportarProductos() {
  yield takeEvery(actions.Types.IMPORTAR_PRODUCTOS_REQUEST, importarProductos);
}

function* watchConfirmarImportacion() {
  yield takeEvery(
    actions.Types.CONFIRMAR_IMPORTACION_REQUEST,
    confirmarImportacion,
  );
}

const importadorProductosSagas = [
  fork(watchDescargarTemplate),
  fork(watchImportarProductos),
  fork(watchConfirmarImportacion),
];

export default importadorProductosSagas;
